import Vue from 'vue'
import Vuex from 'vuex'
import baseData from './modules/baseData'
import errorLog from './modules/errorLog'
import user from './modules/user'
import project from './modules/project'
import system from './modules/system'
import socket from './modules/socket'
import timingControl from './modules/timingControl'
import machine from './modules/machine'
import getters from './getters'
Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        baseData,
        user,
        project,
		system,
        socket,
        timingControl,
        errorLog,
        machine,
    },
    getters
})

export default store;